/*
 *
 * Copyright (C) 2021 NetBase Solutions, Inc.
 * 3960 Freedom Circle Suite 201 Santa Clara, CA 95054
 * All rights reserved.
 */

import Category from '../../enums/Category'
import { rounding } from '../widgetUtil'
import InsightCountVo from '../../vo/action/InsightCount'
import { InsightCount } from '../../schemas/action/InsightCountSchema'
import { InsightData } from '../../schemas/action/InsightDataSchema'
import { InsightGroupInfo } from '../../schemas/action/InsightGroupInfoSchema'

function getInsightDataFromGroupInfo(
  insightCount: InsightCount,
  insightGroupInfo: InsightGroupInfo
): InsightData {
  const insight = insightCount.insights![insightGroupInfo.insightIdx!]
  const insightDataSet = insight.dataset![insightGroupInfo.datasetIdx!]
  return insightDataSet.set![insightGroupInfo.dataIdx!]
}

function comparator(a: InsightData, b: InsightData): number {
  return b.value! - a.value!
}

export default function postProcess(obj: unknown): InsightCount {
  const insightCount = InsightCountVo(obj)

  if (!insightCount.insights) {
    return insightCount
  }

  insightCount.insights.forEach((insight) => {
    insight
      .dataset!.filter((data) =>
        [Category.HASHTAGS, Category.TRENDING_HASHTAGS, Category.BENCHMARK_HASHTAGS].includes(
          data.insightType!
        )
      )
      .forEach((data) => {
        data.set!.forEach((entry) => {
          const dataEntry = entry
          dataEntry.name = `#${dataEntry.name}`
        })
      })

    insight
      .dataset!.filter((data) =>
        [Category.TAGS, Category.DOC_HIERARCHY].includes(data.insightType!)
      )
      .forEach((data) => {
        data.set!.forEach((entry) => {
          const dataEntry = entry
          // TODO not defined in schema
          // @ts-ignore
          dataEntry.overallStarRatingsAverage = rounding(entry.overallStarRatingsAverage, 1)
          // @ts-ignore
          dataEntry.overallSurveyScoresAverage = rounding(entry.overallSurveyScoresAverage, 1)
        })
      })
  })

  if (!insightCount.insightGroupInfos) {
    return insightCount
  }

  insightCount.insightGroupInfos.forEach((insightGroupInfoList) => {
    if (insightGroupInfoList) {
      const baseGroupInfo = insightGroupInfoList[0]
      const baseInsightData = getInsightDataFromGroupInfo(insightCount, baseGroupInfo)

      // TODO: variants is not defined
      // @ts-ignore
      baseInsightData.variants = []
      const variantGroupInfoList = insightGroupInfoList.slice(1)
      variantGroupInfoList.forEach((variantGroupInfo) => {
        const variantInsightData = getInsightDataFromGroupInfo(insightCount, variantGroupInfo)
        // @ts-ignore
        baseInsightData.variants.push(variantInsightData.name)
        baseInsightData.value! += variantInsightData.value!

        // TODO: type of set
        // @ts-ignore
        insightCount.insights![variantGroupInfo.insightIdx!].dataset![
          variantGroupInfo.datasetIdx!
        ].set![variantGroupInfo.dataIdx!] = null
      })
    }
  })

  insightCount.insights.forEach((insight) => {
    if (!insight) return
    insight.dataset!.forEach((datasetEntry) => {
      const data = datasetEntry
      data.set = data.set!.filter((entry) => entry)
    })
  })

  insightCount.insights.forEach((insight) => {
    if (!insight) return
    insight.dataset!.forEach((data) => {
      data.set!.sort(comparator)
    })
  })

  return insightCount
}
